module.exports = __webpack_public_path__ + "static/media/image3.c3c91b16.svg";